<template><div><component-combinator component-name="DtItemLayout" /><h2 id="with-default-styling" tabindex="-1" class="d-docsite--header-2">With Default Styling <a class="header-anchor d-link d-docsite--link d-link" href="#with-default-styling" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">By default, item layout includes custom styling, like paddings, sizes, colors, etc.</p>
<code-example source-code='&lt;dt-item-layout&gt;
  &lt;template #start&gt;
    &lt;dt-icon size=&quot;300&quot; name=&quot;lock&quot; /&gt;
  &lt;/template&gt;
  Layout title
  &lt;template #subtitle&gt;
    Subtitle
  &lt;/template&gt;
  &lt;template #bottom&gt;
    &lt;dt-badge&gt;Content&lt;/dt-badge&gt;
  &lt;/template&gt;
  &lt;template #end&gt;
    &lt;dt-icon size=&quot;300&quot; name=&quot;share&quot; /&gt;
  &lt;/template&gt;
  &lt;template #selected&gt;
    &lt;dt-icon size=&quot;300&quot; name=&quot;check&quot; /&gt;
  &lt;/template&gt;
&lt;/dt-item-layout&gt;'>
<div data-demo-wrapper class="d-d-block d-w-500">
  <dt-item-layout>
    <template #start>
      <dt-icon size="300" name="lock" />
    </template>
    Layout title
    <template #subtitle>
      Subtitle
    </template>
    <template #bottom>
      <dt-badge>Content</dt-badge>
    </template>
    <template #end>
      <dt-icon size="300" name="share" />
    </template>
    <template #selected>
      <dt-icon size="300" name="check" />
    </template>
  </dt-item-layout>
</div>
</code-example>
<h2 id="without-styling" tabindex="-1" class="d-docsite--header-2">Without Styling <a class="header-anchor d-link d-docsite--link d-link" href="#without-styling" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Setting the <code v-pre>unstyled</code> property will add <code v-pre>d-item-layout--custom</code> class. This will change the item-layout from flexbox to grid, removing all the custom styling while maintaining the slots positions.</p>
<p class="d-docsite--paragraph">This way you can utilize the layout and customize your own styling using utility classes.</p>
<code-example source-code='&lt;dt-item-layout unstyled&gt;
  &lt;template #start&gt;
    &lt;dt-icon size=&quot;300&quot; name=&quot;lock&quot; /&gt;
  &lt;/template&gt;
  Layout title
  &lt;template #subtitle&gt;
    Subtitle
  &lt;/template&gt;
  &lt;template #bottom&gt;
    &lt;dt-badge&gt;Content&lt;/dt-badge&gt;
  &lt;/template&gt;
  &lt;template #end&gt;
    &lt;dt-icon size=&quot;300&quot; name=&quot;share&quot; /&gt;
  &lt;/template&gt;
  &lt;template #selected&gt;
    &lt;dt-icon size=&quot;300&quot; name=&quot;check&quot; /&gt;
  &lt;/template&gt;
&lt;/dt-item-layout&gt;'>
<div data-demo-wrapper class="d-d-block d-w-500">
  <dt-item-layout unstyled>
    <template #start>
      <dt-icon size="300" name="lock" />
    </template>
    Layout title
    <template #subtitle>
      Subtitle
    </template>
    <template #bottom>
      <dt-badge>Content</dt-badge>
    </template>
    <template #end>
      <dt-icon size="300" name="share" />
    </template>
    <template #selected>
      <dt-icon size="300" name="check" />
    </template>
  </dt-item-layout>
</div>
</code-example>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="itemLayout" /></div></template>


